import React, { Fragment } from 'react';
import { css, StyleSheet } from 'aphrodite';
import { ApiHelper } from '../../../common/helpers/ApiHelper';
import { Helper } from '../../../common/helpers/Helper';
import { AppTheme } from '../../../styles/AppTheme';
import { AppConfig } from '../../../AppConfig';
import { CustomBaseEnityStyles } from '../../../styles/CustomStyles';
import { Controller } from '../../../common/Controller';
import { CircularProgress } from '@material-ui/core';
import { Component } from 'react';
import { AppButton } from '../../../common/components/AppButton';
import { Link } from 'react-router-dom';

export class CampaignPg extends Component {

  constructor(props) {
    super(props)
    this.pageKey = 'CampaignPg'
    // this.pageTitle = Helper.getString('campaignPg')
    this.orgId = this.props.match.params.orgId
    this.campaignId = this.props.match.params.id
    this.state = {
      fetchState: ApiHelper.State.LOADING,
    };
  }

  componentDidMount() {
    this.fetchItems();
  }

  async fetchItems() {
    try {
      const response = await ApiHelper.callAwait({
        method: 'PUT',
        endPoint: ApiHelper.makeUrlPath(['campaigns', this.campaignId]),
        jsonBody: {
          updateAction: 'reconcileSubscription'
        }
      })
      const pathname = '/admin/advertisers/' + this.orgId + '/campaigns/' + this.campaignId
      Controller.get().pushRoute(pathname);
    } catch (err) {
      this.setState({
        fetchState: ApiHelper.State.ERROR,
        errMsg: Helper.getErrorMsg(err)
      })
    }
  }

  paymentLoadingView() {
    return (
      <div className={css(Styles.container)}>
        <div className={css(Styles.progressContainer)}>
          <p className={css(Styles.title)}>Payment in progress</p>
          <CircularProgress size={window.innerWidth < 768 ? 34 : 44} className={css(Styles.progress)} />
        </div>
        <img className={css(Styles.img)} src={require('../../../assets/images/dolphin-login.png')} />
      </div>
    )
  }

  paymentErrorView() {
    return (
      <div className={css(Styles.container)}>
        <span className={css(Styles.errMsg)}>{this.state.errMsg}</span>
        <Link to={`/admin/advertisers/${this.orgId}/campaigns`} className={css(Styles.link)}>
          <AppButton
            buttonText={'Campaigns'}
          />
        </Link>
      </div>
    )
  }

  render() {
    if (this.state.fetchState === ApiHelper.State.LOADING) {
      return this.paymentLoadingView()
    } else if (this.state.fetchState === ApiHelper.State.ERROR) {
      return this.paymentErrorView()
    } else {
      return ''
    }
  }
}

const Styles = (AppConfig.CUSTOM_STYLE) ? CustomBaseEnityStyles : StyleSheet.create({
  title: {
    fontSize: 26,
    '@media (max-width: 767px)': {
      fontSize: 20,
    }
  },
  container: {
    minHeight: '80vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  img: {
    height: 450,
    '@media (max-width: 767px)': {
      height: 300,
    }
  },
  progress: {
    color: AppTheme.primaryColor
  },
  progressContainer: {
    display: 'flex',
    gap: 20,
    alignItems: 'center'
  },
  link: {
    textDecoration: 'none'
  },
  errMsg: {
    color: '#000000',
    marginBottom: 10
  }
})


// WEBPACK FOOTER //
// ./src/screens/admin/advertisers/CampaignPg.js